/*
 * <info-popup> / <info-popup-button> — the small centred popup the PDP price
 * line opens for shipping costs (live: a legacy-prefixed element pair inside
 * its pdp bundle, rebuilt standalone).
 *
 * A button names its popup via aria-controls. The popup closes on the close
 * button, on a backdrop click and on Escape; focus returns to the opener.
 * Without JS the note is plain text and nothing opens — the information also
 * lives on the shipping help page live links elsewhere.
 */
(() => {
  if (!customElements.get('info-popup')) {
    customElements.define(
      'info-popup',
      class InfoPopup extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            if (event.target === this || event.target.closest('.btn-close')) {
              this.close();
            }
          });
          this.onKeydown = (event) => {
            if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
          };
          document.addEventListener('keydown', this.onKeydown);
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.onKeydown);
        }

        open(opener) {
          this.opener = opener;
          this.classList.add('is-open');
          document.body.classList.add('overflow-hidden');
          const panel = this.querySelector('.popup-inner');
          if (panel) {
            panel.setAttribute('tabindex', '-1');
            panel.focus();
          }
        }

        close() {
          this.classList.remove('is-open');
          document.body.classList.remove('overflow-hidden');
          if (this.opener) this.opener.focus();
        }
      }
    );
  }

  if (!customElements.get('info-popup-button')) {
    customElements.define(
      'info-popup-button',
      class InfoPopupButton extends HTMLElement {
        connectedCallback() {
          this.setAttribute('role', 'button');
          this.setAttribute('tabindex', '0');
          this.addEventListener('click', (event) => {
            event.preventDefault();
            this.openPopup();
          });
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.openPopup();
            }
          });
        }

        openPopup() {
          const popup = document.getElementById(this.getAttribute('aria-controls'));
          if (popup && typeof popup.open === 'function') popup.open(this);
        }
      }
    );
  }
})();
